var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAppLayout',{attrs:{"has-header":""}},[_c('VAppHeader',[_c('VHeader',[(_vm.mainPackData)?_c('VHeaderPrescriptionMenu'):_vm._e()],1)],1),_c('VAppMain',{attrs:{"loading":!_vm.mainPackData}},[(_vm.mainPackData)?_c('RouterView'):_vm._e()],1),_c('VChooseTask'),_c('VImagePopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }